module.exports = __webpack_public_path__ + "img/secbanner.68fd07a1.png";